import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';

import './StartPhraseCell.css';

interface PhraseCellProps {
    text: string;
    mods?: {
        [key: string]: string | boolean;
    };
}

export class StartPhraseCell extends React.Component<PhraseCellProps> {
    render() {
        const { text, mods, children } = this.props;

        return (
            <div
                title={text}
                className={Bem.cls({
                    block: 'selection-list-phrase-cell',
                    mods: mods
                })}
            >
                <span className={Bem.cls('selection-list-phrase-cell', 'text')}>{text}</span>

                <span className={Bem.cls('selection-list-phrase-cell', 'icons')}>{children}</span>
            </div>
        );
    }
}
